export enum retroEnum {
    retrospective='Rückblick'
}